<div class="gl-reports__surveys">
  <div class="gl-reports__surveys--card">
    <div class="gl-reports__surveys--card__item">
      <div class="gl-reports__surveys--title">{{ 'surveys.charts.applicable' | translate }}</div>
      <div class="gl-reports__surveys--chart padding-top-big">
        <gl-chart-circle [progress]="ratioApplication"></gl-chart-circle>
      </div>
    </div>
    <div class="gl-reports__surveys--card__item">
      <div class="gl-reports__surveys--title">{{ 'surveys.charts.opinion' | translate }}</div>
      <div class="gl-reports__surveys--chart padding-top-gap">
        <gl-chart-bar [data]="opinionsSummary"></gl-chart-bar>
      </div>
    </div>
    <div class="gl-reports__surveys--card__item">
      <div class="gl-reports__surveys--title">{{ 'surveys.charts.recommendationRatio' | translate }}</div>
      <div class="gl-reports__surveys--chart padding-top-big">
        <gl-chart-circle [progress]="ratioRecommendation"></gl-chart-circle>
      </div>
    </div>
  </div>
</div>

<lms-toolbar [options]="toolbarConfig"></lms-toolbar>

<div class="gl-table__container">
  <gl-table
    [id]="listId"
    data-testid="marsGroupSurveysList"
    [dataSource]="dataSource"
    [placeholder]="'actions.noResultTable' | translate"
    paginator
    scroll
    (onDatasourceUpdate)="onDatasourceUpdate()"
  >
  </gl-table>
</div>
